const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

function parseInstant(value: string | null | undefined): number | null {
  if (!value) return null;
  const instant = new Date(value).getTime();
  return Number.isNaN(instant) ? null : instant;
}

export function formatRelativeTime(value: string | null | undefined, now: number): string | null {
  const instant = parseInstant(value);
  if (instant === null) return null;

  const elapsed = Math.max(now - instant, 0);
  if (elapsed < MINUTE_MS) return 'just now';
  if (elapsed < HOUR_MS) return `${Math.floor(elapsed / MINUTE_MS)}m ago`;
  if (elapsed < DAY_MS) return `${Math.floor(elapsed / HOUR_MS)}h ago`;
  return `${Math.floor(elapsed / DAY_MS)}d ago`;
}

export function formatDateTime(value: string | null | undefined): string | null {
  const instant = parseInstant(value);
  if (instant === null) return null;
  return new Date(instant).toLocaleString(undefined, { dateStyle: 'full', timeStyle: 'short' });
}

export function formatDate(value: string | null | undefined): string | null {
  const instant = parseInstant(value);
  if (instant === null) return null;
  return new Date(instant).toLocaleDateString();
}
